module.exports = __webpack_public_path__ + "static/media/ouch.9fe1b181.svg";